import React from 'react';
import { format as formatDate } from 'date-fns';
import { TextInput } from '@dashboard/components/Formik';
import { TimeZoneLabel } from '@dashboard/components/TimeZoneLabel';
import { buildRedeemBy, END_OF_DAY } from './buildRedeemBy';

export const initialExpiry = redeemBy => {
  if (!redeemBy) return { expires: 'never', redeemByDate: '', redeemByTime: END_OF_DAY };
  const date = new Date(redeemBy);
  return {
    expires: 'date',
    redeemByDate: formatDate(date, 'yyyy-MM-dd'),
    redeemByTime: formatDate(date, 'HH:mm'),
  };
};

export const expiryRedeemBy = ({ expires, redeemByDate, redeemByTime }) =>
  expires === 'date' && redeemByDate ? buildRedeemBy(redeemByDate, redeemByTime) : undefined;

export const expiryFields = ({ visible, values }) => [
  {
    type: 'select',
    name: 'expires',
    label: 'Expires',
    required: true,
    showRequired: true,
    options: [
      { value: 'never', label: "Doesn't expire" },
      { value: 'date', label: 'On a date' },
    ],
    visible,
  },
  {
    type: 'columns',
    columns: 2,
    gap: 'sm',
    className: 'max-sm:grid-cols-1',
    fields: [
      {
        type: 'date',
        name: 'redeemByDate',
        'aria-label': 'Expiry date',
        // The browser's own required check: a schema error would show the moment On a date is
        // picked and stay after the date is filled in, as these fields don't validate on change.
        required: visible && values.expires === 'date',
      },
      {
        type: 'custom',
        name: 'redeemByTime',
        renderField: (_field, { values: formValues }) => (
          <div className="flex items-center gap-2">
            <TextInput type="time" name="redeemByTime" aria-label="Expiry time" />
            <TimeZoneLabel
              date={expiryRedeemBy(formValues)}
              className="shrink-0 text-sm text-gray-500 dark:text-muted-foreground"
            />
          </div>
        ),
      },
    ],
    helpText: 'Customers can use it until this date and time.',
    visible: visible && values.expires === 'date',
  },
];
